import { useState, useEffect } from 'react';

export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  content: string;
  published: string;
  updated: string;
  url: string;
  labels: string[];
  author: string;
}

export interface BlogLabel {
  name: string;
  count: number;
  slug: string;
}

export interface BlogData {
  posts: BlogPost[];
  labels: BlogLabel[];
}

export function useBlogData() {
  const [data, setData] = useState<BlogData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetch('/api/blog')
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch blog data');
        return res.json();
      })
      .then(json => {
        setData(json);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching blog data:', err);
        // Fallback to static data if API fails
        import('../data/blogData.json').then(module => {
           setData(module.default as BlogData);
           setLoading(false);
        }).catch(fallbackErr => {
           setError(err);
           setLoading(false);
        });
      });
  }, []);

  return { data, loading, error };
}
